/**
 * Centralized product-name resolution.
 *
 * zdhc_products.name is a language-keyed JSON (e.g. {"it": "...", "en": "..."}):
 * resolution order is current locale -> 'en' -> first available key.
 *
 * Per un prodotto locale la fonte e' sempre e solo `name`, il nome scritto
 * dall'utente. E' su quello che si basa il funzionamento dell'applicazione: e'
 * il termine con cui si interroga il catalogo ZDHC ed e' il nome che si mostra.
 *
 * Prima `zdhc_name` vinceva quando presente, e il risolutore lato backend cercava
 * comunque con `products.name`: le due parti cercavano quindi con termini
 * diversi, e a parita' di prodotto potevano dare esiti diversi. I nomi ufficiali
 * imparati dai match non sono spariti — vivono in `product_aliases` e servono a
 * ricollegare un CSV al prodotto giusto — ma non decidono piu' ne' cosa si cerca
 * ne' cosa si mostra.
 */

export const resolveZdhcName = (name, locale) =>
{
    if(!name) return '';

    let parsed = name;
    if(typeof name === 'string')
    {
        try
        {
            parsed = JSON.parse(name);
        }
        catch(e)
        {
            return name.toLowerCase();
        }
    }
    if(typeof parsed !== 'object' || parsed === null) return String(parsed).toLowerCase();

    const value = parsed[locale] || parsed['en'] || parsed[Object.keys(parsed)[0]];
    return value ? value.toLowerCase() : '';
};

export const resolveProductName = (product) =>
{
    if(!product) return '';
    return product.name || '';
};
